import m from "../../../../geodata/es2015/region/world/europeUltra";
window.am4geodata_region_world_europeUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/europeUltra.js
// module id = null
// module chunks = 